<template>
    <i :class="classNames"></i>
</template>

<script>

    export default {
        name: "AppIcon",
        props: {
            fontClass: {
                type: String,
                default: 'iconfont'
            },
            prefixClass: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            }
        },
        data() {
            return {}
        },
        computed: {
            classNames() {
                const {fontClass, prefixClass, value} = this
                const iconClassName = `${prefixClass}${value}`
                return ['app-icon',fontClass,iconClassName]
                // return `app-icon ${} ${iconClassName}`
            }
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";

    .app-icon {
        color: $textColor;
        color: var(--textColor);
    }
</style>